import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import { Redirect } from 'react-router-dom';

import { getUserFeatures } from '../../selectors';
import { routerProps } from '../../../../propTypes';

const propTypes = exact({
  features: PropTypes.object.isRequired,
  ...routerProps,
});

const RedirectLandingPage = (props) => {
  const {
    per_diem_request: perDiemRequest,
    viewer,
  } = props.features;

  const handleRender = () => {
    if (perDiemRequest) {
      return <Redirect to="/per-diem/requests" />;
    } if (viewer) {
      return <Redirect to="/submissions/tickets" />;
    }

    return <Redirect to="/submissions/processor" />;
  };

  return (
    handleRender()
  );
};

RedirectLandingPage.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    features: getUserFeatures(state),
  };
};

const withRedux = connect(mapStateToProps, {});

export default withRedux(RedirectLandingPage);
